export function contentHeightEventHandler(payload: { height?: number; context?: 'similar' }) {
  const { height, context } = payload || {};
  if (!height || !context) return;

  const dynamicMargin = 50;
  const iframe = document.getElementById(`fashion-hint-iframe-${context}`) as HTMLIFrameElement | null;
  if (iframe) {
    iframe.style.height = `${height + dynamicMargin}px`;
  }
}
